import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import { divisionFormatTypeIds } from '../../../utils/eventConstants';
import { SearchFilters } from '../../../utils/search';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';

const FlexLeagueGameTypeFilter = (props) => {
    const {
        filters,
        filterModal,
        handleFilterClick,
        closeModals,
        filterInputs,
        searchTypes,
        handleFilterSubmit,
        clearFilters,
        handleFilterUpdate,
        mobileOnly,
        desktopOnly,
        'data-testid': dataTestId,
    } = props;

    const updateSearchTypes = {
        ...searchTypes,
        eventTeamTypes: searchTypes.eventTeamTypes.filter((type) => {
            return type.id !== divisionFormatTypeIds.DINGLES;
        }),
    };

    const isFilterActive = (filters?.eventTeamTypes && Object.values(filters.eventTeamTypes).indexOf(true) > -1) || filterModal === SearchFilters.EVENT_TEAM_TYPES;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={SearchFilters.EVENT_TEAM_TYPES}
                handleFilterClick={handleFilterClick}
                isActive={isFilterActive}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Game Type
            </Filter>
            {filterModal === SearchFilters.EVENT_TEAM_TYPES && (
                <FilterModal
                    title={'Game Type'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters(SearchFilters.EVENT_TEAM_TYPES)}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilterByType
                            searchTypes={updateSearchTypes}
                            searchTypesPropName={SearchFilters.EVENT_TEAM_TYPES}
                            filterInputs={filterInputs}
                            filtersPropName={SearchFilters.EVENT_TEAM_TYPES}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    [SearchFilters.EVENT_TEAM_TYPES]: {
                                        ...filterInputs.eventTeamTypes,
                                        [value]: !filterInputs.eventTeamTypes[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default FlexLeagueGameTypeFilter;
